<template>
    <div class="row">

        <div style="width:380px">

            <fieldset>
                <legend>对齐方式</legend>
                <div class="param-row">
                    <label>方式:</label>
                    <select v-model="type">
                        <option value="4side">四面分中</option>
                    </select>
                </div>
            </fieldset>

            <fieldset>
                <legend>探头参数</legend>
                <div class="param-row">
                    <label>探头直径:</label>
                    <NumberInput v-model="probeDiameter" style="width:80px" />
                    <span class="hint">半径: {{ probeRadius.toFixed(2) }}mm</span>
                </div>
            </fieldset>

            <fieldset>
                <legend>探头坐标</legend>
                <div class="param-row">
                    <label>P0 参考点:</label>
                    <span>X0: 0, Y0: 0</span>
                </div>
                <div class="param-row">
                    <label>P1[后]:</label>
                    X<NumberInput v-model="x1" style="width:80px" @paste-pair="([x, y]) => { x1 = x; y1 = y }" @change="inputChanged" @enter="nextNumber(0)" data-nav="0" />
                    Y<NumberInput v-model="y1" style="width:80px" @paste-pair="([x, y]) => { x1 = x; y1 = y }" @change="inputChanged" @enter="nextNumber(1)" data-nav="1" />
                </div>
                <div class="param-row">
                    <label>P2[右]:</label>
                    X<NumberInput v-model="x2" style="width:80px" @paste-pair="([x, y]) => { x2 = x; y2 = y }" @change="inputChanged" @enter="nextNumber(2)" data-nav="2" />
                    Y<NumberInput v-model="y2" style="width:80px" @paste-pair="([x, y]) => { x2 = x; y2 = y }" @change="inputChanged" @enter="nextNumber(3)" data-nav="3" />
                </div>
                <div class="param-row">
                    <label>P3[前]:</label>
                    X<NumberInput v-model="x3" style="width:80px" @paste-pair="([x, y]) => { x3 = x; y3 = y }" @change="inputChanged" @enter="nextNumber(4)" data-nav="4" />
                    Y<NumberInput v-model="y3" style="width:80px" @paste-pair="([x, y]) => { x3 = x; y3 = y }" @change="inputChanged" @enter="nextNumber(5)" data-nav="5" />
                </div>
                <div class="param-row">
                    <label>P4[左]:</label>
                    X<NumberInput v-model="x4" style="width:80px" @paste-pair="([x, y]) => { x4 = x; y4 = y }" @change="inputChanged" @enter="nextNumber(6)" data-nav="6" />
                    Y<NumberInput v-model="y4" style="width:80px" @paste-pair="([x, y]) => { x4 = x; y4 = y }" @change="inputChanged" @enter="nextNumber(7)" data-nav="7" />
                </div>
                <div class="param-row">
                    <button @click="exportCoords" style="font-size:11px">导出文件</button>
                    <button @click="triggerImport" style="font-size:11px;margin-left:4px">导入文件</button>
                    <button @click="copyCoords" style="font-size:11px;margin-left:4px">导出JSON</button>
                    <button @click="pasteCoords" style="font-size:11px;margin-left:4px">导入JSON</button>
                    <input type="file" ref="importFileInput" accept=".json" style="display:none" @change="importCoords" />
                </div>
                <div v-if="showDialog" class="param-row">
                    <textarea v-model="dialogText" :placeholder="dialogMode === 'copy' ? '探头坐标JSON（长按全选复制）:' : '在此粘贴探头坐标JSON...'" :readonly="dialogMode === 'copy'" style="width:100%;height:80px;font-size:11px"></textarea>
                    <div style="margin-top:2px">
                        <button v-if="dialogMode === 'paste'" @click="confirmPaste" style="font-size:11px">确认导入</button>
                        <button v-if="dialogMode === 'copy'" @click="dialogCopy" style="font-size:11px">复制</button>
                        <button @click="showDialog = false" style="font-size:11px;margin-left:4px">关闭</button>
                    </div>
                </div>
            </fieldset>

            <fieldset>
                <legend>工件信息</legend>
                <div class="param-row">
                    <label>工件中心:</label>
                    <span>{{workpiece.x.toFixed(3)}}, {{workpiece.y.toFixed(3)}}</span>
                    <button @click="generateCenterNC" style="margin-left:6px;font-size:11px">生成NC</button>
                </div>
                <div class="param-row">
                    <label>工件尺寸:</label>
                    <span>{{workpiece.w.toFixed(3)}} x {{workpiece.h.toFixed(3)}}</span>
                </div>
                <div class="param-row">
                    <label>装夹偏置角度:</label>
                    <NumberInput :modelValue="workpiece.angle * RAD2DEG" style="width:100px" @update:modelValue="v => workpiece.angle = v * DEG2RAD" />°
                </div>
                <div class="param-row">
                    <label>装夹偏置弧度:</label>
                    <NumberInput v-model="workpiece.angle" style="width:100px" />
                </div>
            </fieldset>

            <fieldset>
                <legend>操作</legend>
                <button @click="locateCenter">分中定位</button>
                <div class="param-row" style="margin-top:8px">
                    <label style="width:auto">
                        <input type="checkbox" v-model="autoClearG43">
                        自动清理刀具补偿(G43)
                    </label>
                </div>
                <button @click="relocateNC" style="margin-top:8px">重新定位</button>
            </fieldset>

            <fieldset>
                <legend>坐标点重定位</legend>
                <div class="param-row">
                    <label>输入坐标:</label>
                    X<NumberInput v-model="ix" style="width:80px" @paste-pair="([x, y]) => { ix = x; iy = y }" @change="inputChanged" />
                    Y<NumberInput v-model="iy" style="width:80px" @paste-pair="([x, y]) => { ix = x; iy = y }" @change="inputChanged" />
                </div>
                <button @click="relocatePoint">重定位坐标点</button>
                <div v-for="(point,i) in inputPointsList" :key="i" class="param-row">
                    <label>点 {{i+1}}:</label>
                    <span>({{point.ix}},{{point.iy}}) => ({{point.ox.toFixed(3)}},{{point.oy.toFixed(3)}})</span>
                    <button @click="removePoint(i)">x</button>
                </div>
            </fieldset>

        </div>

        <div class="grow" style="text-align: center;">
            <canvas ref="canvas" class="" :width="CanvasW" :height="CanvasH" style="width:601px;height:601px"></canvas>
        </div>

    </div>
</template>

<style>

</style>

<script>
import {reactive, ref, inject, computed, watch} from "vue"
import NumberInput from "./NumberInput.vue"
import { fmtNC } from "../util/nc-format.js"
import { downloadTextFile } from "../util/browser-fs.js"

const RAD2DEG = 180/Math.PI
const DEG2RAD = Math.PI/180

const CanvasW = 601
const CanvasH = 601

export default {
    components: { NumberInput },
    setup() {
        const STORAGE_KEY = 'nc-helper-align-state-v2'

        function loadState() {
            try {
                const saved = localStorage.getItem(STORAGE_KEY)
                return saved ? JSON.parse(saved) : null
            } catch {
                return null
            }
        }

        function saveState(state) {
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
            } catch {
                // 静默忽略存储错误
            }
        }

        const fileManager = inject("fileManager")
        const importFileInput = ref(null)
        const showDialog = ref(false)
        const dialogText = ref('')
        const dialogMode = ref('paste')  // 'copy' | 'paste'
        const saved = loadState()

        const type = ref(saved?.type ?? "4side")
        const x1 = ref(saved?.x1 ?? 128.366)
        const y1 = ref(saved?.y1 ?? 0.26)
        const x2 = ref(saved?.x2 ?? 129.693)
        const y2 = ref(saved?.y2 ?? 98.282)
        const x3 = ref(saved?.x3 ?? 65.345)
        const y3 = ref(saved?.y3 ?? 167.609)
        const x4 = ref(saved?.x4 ?? -1.911)
        const y4 = ref(saved?.y4 ?? 98.282)

        const autoClearG43 = ref(saved?.autoClearG43 ?? true)
        const ix = ref(saved?.ix ?? 0)
        const iy = ref(saved?.iy ?? 0)
        const inputPointsList = reactive(saved?.inputPointsList ?? [])

        const workpiece = reactive({
            angle: saved?.workpieceAngle ?? 5 * DEG2RAD,
            x: 0,
            y: 0,
            w: 0,
            h: 0,
        })

        const probeDiameter = ref(saved?.probeDiameter ?? 2)
        const probeRadius = computed(() => probeDiameter.value / 2)

        watch(
            () => ({
                type: type.value,
                x1: x1.value, y1: y1.value,
                x2: x2.value, y2: y2.value,
                x3: x3.value, y3: y3.value,
                x4: x4.value, y4: y4.value,
                probeDiameter: probeDiameter.value,
                workpieceAngle: workpiece.angle,
                autoClearG43: autoClearG43.value,
                inputPointsList: [...inputPointsList],
                ix: ix.value, iy: iy.value,
            }),
            (state) => saveState(state),
            { deep: true }
        )

        return {
            type, x1, y1, x2, y2, x3, y3, x4, y4,
            autoClearG43, ix, iy,
            inputPointsList,
            workpiece,
            probeDiameter, probeRadius,
            RAD2DEG, DEG2RAD, CanvasW, CanvasH,
            fileManager,
            importFileInput,
            showDialog,
            dialogText,
            dialogMode,
        }
    },
    mounted() {
        this.ctx = this.$refs.canvas.getContext("2d")
    } ,

    methods: {
        locateCenter() {
            // 角度：P0-P1 连线与 X 轴夹角（atan2）
            const angle = Math.atan2(this.y1, this.x1)
            this.workpiece.angle = angle

            const pr = this.probeRadius

            // 将所有探头坐标旋转到对齐坐标系（后边界与X轴平行）
            const [rx2] = rotateVector(this.x2, this.y2, -angle)
            const [, ry3] = rotateVector(this.x3, this.y3, -angle)
            const [rx4] = rotateVector(this.x4, this.y4, -angle)

            // 四条边界在旋转坐标系中的位置：
            // 后边界：与P0(原点)和P1探头相切 → y = pr（探头圆心在y=0，边界在y=pr）
            // 前边界：与P3相切，平行于后边界 → y = ry3 - pr（探头在前边界外侧）
            // 左边界：与P4相切，垂直于P0-P1 → x = rx4 + pr（探头在左边界外侧）
            // 右边界：与P2相切，垂直于P0-P1 → x = rx2 - pr（探头在右边界外侧）
            const backY  = pr
            const frontY = ry3 - pr
            const leftX  = rx4 + pr
            const rightX = rx2 - pr

            // 工件尺寸
            this.workpiece.h = frontY - backY
            this.workpiece.w = rightX - leftX

            // 旋转坐标系中的中心点
            const cxRot = (leftX + rightX) / 2
            const cyRot = (backY + frontY) / 2

            // 转回原始坐标系
            ;[this.workpiece.x, this.workpiece.y] = rotateVector(cxRot, cyRot, angle)

            this.draw()
        } ,

        generateCenterNC() {
            const x = this.workpiece.x.toFixed(3)
            const y = this.workpiece.y.toFixed(3)
            const nc = [
                'G90',
                `G0 X${x} Y${y}`,
                ''
            ].join('\r\n')
            this.fileManager.addFileTab('move-to-center.nc', nc)
        } ,

        exportCoords() {
            const data = {
                type: this.type,
                probeDiameter: this.probeDiameter,
                points: {
                    p1: { x: this.x1, y: this.y1 },
                    p2: { x: this.x2, y: this.y2 },
                    p3: { x: this.x3, y: this.y3 },
                    p4: { x: this.x4, y: this.y4 },
                }
            }
            downloadTextFile(JSON.stringify(data, null, 2), 'probe-coords.json')
        } ,

        triggerImport() {
            this.$refs.importFileInput.value = ''
            this.$refs.importFileInput.click()
        } ,

        importCoords() {
            const file = this.$refs.importFileInput.files?.[0]
            if (!file) return
            const reader = new FileReader()
            reader.onload = () => {
                this.applyCoordsData(reader.result)
            }
            reader.readAsText(file)
        } ,

        copyCoords() {
            const data = {
                type: this.type,
                probeDiameter: this.probeDiameter,
                points: {
                    p1: { x: this.x1, y: this.y1 },
                    p2: { x: this.x2, y: this.y2 },
                    p3: { x: this.x3, y: this.y3 },
                    p4: { x: this.x4, y: this.y4 },
                }
            }
            this.dialogMode = 'copy'
            this.dialogText = JSON.stringify(data, null, 2)
            this.showDialog = true
        } ,

        pasteCoords() {
            navigator.clipboard.readText().then(text => {
                this.applyCoordsData(text)
            }).catch(() => {
                this.dialogMode = 'paste'
                this.dialogText = ''
                this.showDialog = true
            })
        } ,

        confirmPaste() {
            if (!this.dialogText.trim()) return
            this.applyCoordsData(this.dialogText)
            this.showDialog = false
        } ,

        dialogCopy() {
            const text = this.dialogText
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).catch(() => {
                    this.fallbackCopy(text)
                })
            } else {
                this.fallbackCopy(text)
            }
        } ,

        fallbackCopy(text) {
            const ta = document.createElement('textarea')
            ta.value = text
            ta.style.position = 'fixed'
            ta.style.left = '-9999px'
            ta.style.top = '0'
            document.body.appendChild(ta)
            ta.focus()
            ta.select()
            try { document.execCommand('copy') } catch (e) { /* ignore */ }
            document.body.removeChild(ta)
        } ,

        applyCoordsData(text) {
            try {
                const data = JSON.parse(text)
                if (data.type !== undefined) this.type = data.type
                if (data.probeDiameter !== undefined) this.probeDiameter = data.probeDiameter
                const pts = data.points
                if (pts) {
                    // 自动检测旧格式：p2的Y > p3的Y 且 p3的X < p4的X
                    const isOld = pts.p2 && pts.p3 && pts.p4
                        && pts.p2.y > pts.p3.y
                        && pts.p3.x < pts.p4.x
                    if (isOld) {
                        // 旧: p1=后 p2=前 p3=左 p4=右 → 新: P1=后 P2=右 P3=前 P4=左
                        if (pts.p1) { this.x1 = pts.p1.x; this.y1 = pts.p1.y }
                        if (pts.p2) { this.x3 = pts.p2.x; this.y3 = pts.p2.y }
                        if (pts.p3) { this.x4 = pts.p3.x; this.y4 = pts.p3.y }
                        if (pts.p4) { this.x2 = pts.p4.x; this.y2 = pts.p4.y }
                    } else {
                        if (pts.p1) { this.x1 = pts.p1.x; this.y1 = pts.p1.y }
                        if (pts.p2) { this.x2 = pts.p2.x; this.y2 = pts.p2.y }
                        if (pts.p3) { this.x3 = pts.p3.x; this.y3 = pts.p3.y }
                        if (pts.p4) { this.x4 = pts.p4.x; this.y4 = pts.p4.y }
                    }
                }
            } catch (e) {
                alert('导入JSON失败：格式不正确')
            }
        } ,

        relocatePoint() {
            let [ox,oy] = rotateVector(this.ix, this.iy, this.workpiece.angle)
            this.inputPointsList.push({
                ox,oy,
                ix: this.ix ,
                iy: this.iy ,
            })
        } ,

        removePoint(i) {
            this.inputPointsList.splice(i,1)
        } ,

        async relocateNC() {
            // 从右侧文件面板获取当前活动文件
            const activeFile = this.fileManager.getActiveFile()
            if (!activeFile) {
                alert("请先在右侧文件面板中选择要重新定位的NC文件")
                return
            }

            if (Math.abs(this.workpiece.angle) < 1e-5) {
                alert("工件装夹没有发生偏转？")
                return
            }

            // 提示用户确认
            const confirmed = confirm(
                `将使用装夹偏置角度 ${(this.workpiece.angle * RAD2DEG).toFixed(3)}° ` +
                `对文件 "${activeFile.name}" 进行重新定位，是否继续？`
            )
            if (!confirmed) {
                return
            }

            const nc = activeFile.content.replace(/^\s*\n+/, '')
            let gcodes = nc.split("\n")
            console.log(gcodes)

            let absPos = {           // 旋转前的绝对坐标
                X:0, Y:0
            }
            let prevRot = {          // 上一次旋转后的绝对坐标（用于 G91 计算增量）
                X:0, Y:0
            }
            let abs = true
            let gcmd = ''
            for(let l=0;l<gcodes.length;l++) {
                let line = gcodes[l] = gcodes[l].trim()
                if(line.match(/G90/)) {
                    abs = true
                }
                if(line.match(/G91/)) {
                    abs = false
                }

                if(line.match(/G43/) && this.autoClearG43) {
                    gcodes[l] = ''
                    continue
                }

                let res = line.match(/(G(0|1|2|3|28))/)
                if(res) {
                    gcmd = res[1]
                }

                // 圆弧，处理 I/J
                let i = fetchLoc(line, 'I')
                let j = fetchLoc(line, 'J')
                if(!isNaN(i) || !isNaN(j)) {
                    if(isNaN(i)){
                        i = 0
                    }
                    if(isNaN(j)) {
                        j = 0
                    }
                    [i, j] = rotateVector(i, j, this.workpiece.angle)
                    line = line.replace(/[IJ]\-?\d*\.\d*/g, "")
                    i = Math.round(i*1000)/1000
                    j = Math.round(j*1000)/1000
                    line+= ` I${i} J${j}`
                }

                let moved = moveLoc(line, 'X', absPos, abs)
                moved|= moveLoc(line, 'Y', absPos, abs)

                if(!moved) {
                    continue
                }

                // 旋转后的绝对坐标
                let [ox,oy] = rotateVector(absPos.X, absPos.Y, this.workpiece.angle)

                let outX, outY
                if (abs) {
                    // G90: 输出旋转后的绝对坐标
                    outX = ox
                    outY = oy
                } else {
                    // G91: 输出旋转后的增量（当前旋转绝对坐标 - 上次旋转绝对坐标）
                    outX = ox - prevRot.X
                    outY = oy - prevRot.Y
                }
                prevRot.X = ox
                prevRot.Y = oy

                outX = Math.round(outX*1000)/1000
                outY = Math.round(outY*1000)/1000

                let ori = line

                line = line
                            .replace(/[XY]\-?\d*\.?\d*/g, "")
                            .replace(/ {2,}/g, " ")

                console.log(ori, '=>', line)

                line+= ` X${fmtNC(outX)} Y${fmtNC(outY)}`
                gcodes[l] = line.trim()
            }

            const ts = new Date().toLocaleString('zh-CN')
            const deg = (this.workpiece.angle * this.RAD2DEG).toFixed(4)
            const header = `(旋转角度: ${deg}°, 生成时间: ${ts})\r\n`
            const newNc = header + gcodes.join("\r\n")
            console.log(newNc)

            // 生成新文件名并添加到文件面板
            const originalName = activeFile.name
            const newFilename = originalName.replace(/\.nc$/i, '-modified.nc') || originalName + '-modified.nc'
            this.fileManager.addFileTab(newFilename, newNc)
        } ,

        draw() {
            // 重置 canvas
            this.$refs.canvas.width = this.$refs.canvas.width
            this.$refs.canvas.height = this.$refs.canvas.height

            this.drawAxies()
            this.ctx.translate(150, 450)

            // 计算缩放比例
            let max = Math.max(
                Math.abs(this.x1), Math.abs(this.x2), Math.abs(this.x3), Math.abs(this.x4),
                Math.abs(this.y1), Math.abs(this.y2), Math.abs(this.y3), Math.abs(this.y4)
            )
            let scale = 400 / max

            const pr = this.probeRadius
            const prPx = pr * scale
            const angle = this.workpiece.angle

            // === 探头圆心（canvas坐标：canvas_y = -real_y） ===

            // P0: 圆心在原点 (0,0)，半径 prPx 的圆与后边界相切于 y=pr 处
            this.drawPoint(0, 0, "#666", `P0(0,0)`, 20, prPx)

            // P1[后]: 圆心在输入坐标处
            this.drawPoint(this.x1 * scale, -this.y1 * scale, "#666",
                `P1[后](${this.x1.toFixed(3)},${this.y1.toFixed(3)})`, 16, prPx)

            // P2[右]
            this.drawPoint(this.x2 * scale, -this.y2 * scale, "#666",
                `P2[右](${this.x2.toFixed(3)},${this.y2.toFixed(3)})`, -8, prPx)

            // P3[前]
            this.drawPoint(this.x3 * scale, -this.y3 * scale, "#666",
                `P3[前](${this.x3.toFixed(3)},${this.y3.toFixed(3)})`, -8, prPx)

            // P4[左]
            this.drawPoint(this.x4 * scale, -this.y4 * scale, "#666",
                `P4[左](${this.x4.toFixed(3)},${this.y4.toFixed(3)})`, -8, prPx)

            // === 中心点：红色十字 ===
            this.drawCross(this.workpiece.x * scale, -this.workpiece.y * scale, "red",
                `Center(${this.workpiece.x.toFixed(3)},${this.workpiece.y.toFixed(3)})`, 20)

            // === 工件边框：四条边界围成矩形 ===
            // 旋转 P2/P3/P4 到与后边界对齐的坐标系
            const [rx2] = rotateVector(this.x2, this.y2, -angle)
            const [, ry3] = rotateVector(this.x3, this.y3, -angle)
            const [rx4] = rotateVector(this.x4, this.y4, -angle)

            // 边界在旋转坐标系中的位置
            const backY  = pr          // 后边界：与 P0(原点) 探头相切
            const frontY = ry3 - pr    // 前边界：与 P3 相切，∥ 后边界
            const leftX  = rx4 + pr    // 左边界：与 P4 相切，⟂ 后边界
            const rightX = rx2 - pr    // 右边界：与 P2 相切，⟂ 后边界

            // 四个角点：从旋转坐标系转回原始坐标系
            const c1 = rotateVector(leftX,  backY,  angle)  // 后左
            const c2 = rotateVector(rightX, backY,  angle)  // 后右
            const c3 = rotateVector(rightX, frontY, angle)  // 前右
            const c4 = rotateVector(leftX,  frontY, angle)  // 前左

            this.ctx.strokeStyle = "#000"
            this.ctx.beginPath()
            this.ctx.moveTo(c1[0] * scale, -c1[1] * scale)
            this.ctx.lineTo(c2[0] * scale, -c2[1] * scale)
            this.ctx.lineTo(c3[0] * scale, -c3[1] * scale)
            this.ctx.lineTo(c4[0] * scale, -c4[1] * scale)
            this.ctx.lineTo(c1[0] * scale, -c1[1] * scale)
            this.ctx.stroke()
        } ,

        drawAxies() {
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = "#aaa";
            this.ctx.moveTo(0,450);
            this.ctx.lineTo(600,450);
            this.ctx.moveTo(150,0);
            this.ctx.lineTo(150,600);
            this.ctx.stroke();
        } ,

        drawPoint(x, y, color, title, textOffsetY, radius) {
            const r = radius !== undefined ? radius : 5
            this.ctx.strokeStyle = color;
            this.ctx.beginPath()
            this.ctx.arc(x, y, r, 0, 2*Math.PI)
            this.ctx.stroke()

            this.ctx.font = '12px sans-serif'
            this.ctx.textAlign = 'center'
            this.ctx.fillText(title, x, y+textOffsetY)
        } ,

        drawProbe(centerX, centerY, contactX, contactY, radiusPx, title, textOffsetY) {
            // 绘制探头红色圆圈（空心，与边相切）
            this.ctx.strokeStyle = "#cc0000";
            this.ctx.lineWidth = 1;
            this.ctx.beginPath();
            this.ctx.arc(centerX, centerY, radiusPx, 0, 2 * Math.PI);
            this.ctx.stroke();

            // 切点位置绘制黑色实心小圆点
            this.ctx.fillStyle = "black";
            this.ctx.beginPath();
            this.ctx.arc(contactX, contactY, 2.5, 0, 2 * Math.PI);
            this.ctx.fill();

            // 标签文字
            this.ctx.font = "12px sans-serif";
            this.ctx.textAlign = "center";
            this.ctx.fillText(title, contactX, contactY + textOffsetY);
        } ,

        drawCross(x, y, color, title, textOffsetY) {
            // 绘制红色十字（替代红色圆圈）
            const halfLen = 5;
            this.ctx.strokeStyle = color;
            this.ctx.lineWidth = 2;
            this.ctx.beginPath();
            this.ctx.moveTo(x - halfLen, y);
            this.ctx.lineTo(x + halfLen, y);
            this.ctx.moveTo(x, y - halfLen);
            this.ctx.lineTo(x, y + halfLen);
            this.ctx.stroke();
            this.ctx.lineWidth = 1;  // 重置线宽，避免影响后续绘制

            // 标签文字
            this.ctx.fillStyle = color;
            this.ctx.font = "12px sans-serif";
            this.ctx.textAlign = "center";
            this.ctx.fillText(title, x, y + textOffsetY);
        } ,

        nextNumber(idx) {
            const inputs = this.$el.querySelectorAll('[data-nav]')
            idx++
            if(idx>=inputs.length)
                idx = 0
            inputs[idx].focus()
        } ,

        inputChanged () {

        }
    }
}



function fetchLoc(gcode, dir) {
    let regexp = new RegExp(`${dir}(\\-?\\d*\\.?\\d*)`,'i')
    let res = gcode.match(regexp)
    if(!res) {
        return NaN
    }
    return parseFloat(res[1])
}

function moveLoc(gcode, dir, loc, abs) {
    let n = fetchLoc(gcode, dir)
    if(isNaN(n))
        return false
    if(abs) {
        loc[dir] = n
    }
    else {
        loc[dir]+= n
    }
    return true
}

function rotateVector(x,y,rad) {
    return [
        x * Math.cos(rad) - y*Math.sin(rad),
        x * Math.sin(rad) + y*Math.cos(rad)
    ]
}

</script>
